import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

import { Role } from '@futrli-sdk/roles';
import { translateUserRole } from '@futrli/backend-messages/common/user-roles';

interface RoleFilterProps {
  onChange: (value: string) => void;
  roles?: Role[];
  selectedValue: string;
}

export const RoleFilter = ({ onChange, roles = [], selectedValue }: RoleFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = useMemo(
    () => [
      {
        label: intl.formatMessage({ id: 'predict.filters.role.all_roles', defaultMessage: 'All roles' }),
        value: 'all'
      },
      ...roles
        .map(role => ({ label: translateUserRole(role.name, intl), value: role.id }))
        .sort((a, b) => a.label.localeCompare(b.label))
    ],
    [intl, roles]
  );

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({ id: 'common.role', defaultMessage: 'Role' })}
        onChange={handleChange}
        value={selectedValue}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
